import { Package } from "lucide-react";
import { Section, SectionHeading, Card } from "./service-revops-ui";
import { SectionCta } from "./service-revops-section-cta";
import { gohighlevelConfig as defaultConfig } from "./service-platform-config";
import type { PlatformConfig } from "./service-platform-config";

export function ServiceSnapshots({
  config = defaultConfig,
}: {
  config?: PlatformConfig;
} = {}) {
  const snapshots = config.snapshots;
  return (
    <Section>
      <SectionHeading
        eyebrow={config.snapshotsEyebrow}
        navy={config.snapshotsHeadlineNavy}
        blue={config.snapshotsHeadlineBlue}
        sub={config.snapshotsSub}
      />
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
        {snapshots.map((s, i) => (
          <Card key={i} radius={22}>
            <div className="flex items-center justify-between mb-4">
              <div
                className="w-11 h-11 rounded-[14px] flex items-center justify-center shrink-0"
                style={{ background: "#EDF7FF" }}
              >
                <Package className="w-5 h-5" style={{ color: "#0B7CF2" }} />
              </div>
              <span
                className="rounded-full px-3 py-1 font-sans font-bold uppercase"
                style={{
                  fontSize: "10px",
                  letterSpacing: "0.1em",
                  background: "#EAF5FF",
                  color: "#0B7CF2",
                }}
              >
                {s.tag}
              </span>
            </div>
            <h3
              className="font-display font-bold mb-2.5"
              style={{
                fontSize: "16.5px",
                color: "#071E61",
                letterSpacing: "-0.02em",
                lineHeight: 1.2,
              }}
            >
              {s.name}
            </h3>
            <p
              style={{ fontSize: "13.5px", lineHeight: 1.5, color: "#536B89" }}
            >
              {s.desc}
            </p>
          </Card>
        ))}
      </div>
      <SectionCta
        copy={config.snapshotsCtaCopy}
        label={config.snapshotsCtaLabel}
      />
    </Section>
  );
}
